import React from "react"
import { Route, RouteProps, RouteComponentProps } from "react-router-dom"
import appService from "src/AppService"
import NotAllowed from "src/auth/unauthenticated/not_allowed/NotAllowed"

interface ProtectedRouteProps extends RouteProps {
    targets: string | string[]
    hasView?: boolean
    hasEdit?: boolean
    render?: (props: RouteComponentProps) => React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    targets,
    hasView,
    hasEdit,
    render,
    path,
    exact
}) => {
    const permissions = appService.getPermissions(targets)

    const shouldRender = (): boolean => {
        if (hasView !== undefined) {
            return permissions.canView === hasView
        } else if (hasEdit !== undefined) {
            return permissions.canEdit === hasEdit
        } else {
            return permissions.hasRole
        }
    }

    return (
        <Route
            path={path}
            exact={exact}
            render={(props: RouteComponentProps) => {
                if (shouldRender()) {
                    return render ? render(props) : null
                } else {
                    return <NotAllowed/>
                }
            }}
        />
    )
}

export default ProtectedRoute
